"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "malfa": {
    "95bf0ad1": [{
      "hkey": "1ebb27d3",
      "slug": "malfa",
      "name": "Malfa",
      "primary": true,
      "skipSearch": false
    }],
    "capo-faro": [{
      "hkey": "1ebb27d3",
      "slug": "malfa",
      "name": "Malfa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "433346d0": [{
      "hkey": "1ebb27d3",
      "slug": "malfa",
      "name": "Malfa",
      "primary": true,
      "skipSearch": false
    }],
    "gramignazzi": [{
      "hkey": "1ebb27d3",
      "slug": "malfa",
      "name": "Malfa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;